import { createTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import { lightPalette } from './palette';
import { typography } from './typography';
import { components } from './components';

// Base theme configuration
const baseThemeConfig = {
  typography,
  components,
  shape: {
    borderRadius: '0.5rem', // 8px
  },
  spacing: '0.5rem', // 8px
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
};

// Create light theme
export const lightTheme: Theme = createTheme({
  ...baseThemeConfig,
  palette: lightPalette,
});

// Create RTL theme
export const lightThemeRTL: Theme = createTheme({
  ...baseThemeConfig,
  palette: lightPalette,
  direction: 'rtl',
});

// Theme mode type - only light mode supported
export type ThemeMode = 'light';

// Get theme by direction (always light mode)
export const getTheme = (
  _mode: ThemeMode, // Underscore prefix to indicate unused parameter
  direction: 'ltr' | 'rtl' = 'ltr'
): Theme => {
  // Only return light theme variants
  return direction === 'rtl' ? lightThemeRTL : lightTheme;
};
